import { render, staticRenderFns } from "./SpriteLongText.vue?vue&type=template&id=796210aa&"
import script from "./SpriteLongText.vue?vue&type=script&lang=js&"
export * from "./SpriteLongText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports